<template>
  <slot :is-expanded="false" :close="close" />
  <app-resizable-dropdown
    ref="$modal"
    name="job-resize-modal"
    class="job-resize-modal-anchor"
    resizable
    centered
    fit-content-height
    fullscreen-on-mobile
    :initial-width="900"
    :max-width="900"
    :min-width="320"
    :min-height="120"
    :max-height="900"
    :close-by-click-outside="true"
    ignore-click-outside=".dropdown-content, .q-dialog"
    :close-by-esc="false"
    :hide-by-parent-scroll="false"
    @close="handleClose"
  >
    <div ref="$content" class="job-resize-modal">
      <slot v-if="isOpen" :is-expanded="true" :close="close" />
    </div>
  </app-resizable-dropdown>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import { useModalEscape } from "@/composables/useModalEscape";

const $modal = ref<InstanceType<typeof AppResizableDropdown> | null>(null);
const $content = ref<HTMLElement | null>(null);
const isOpen = ref(false);

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
  content: $content,
  close: () => $modal.value?.close(),
});

const handleClose = () => {
  isOpen.value = false;
  deactivateEsc();
};

const close = () => {
  $modal.value?.close();
};

const onOpen = async () => {
  isOpen.value = true;
  await nextTick();
  await $modal.value?.open();
  activateEsc();
};

defineExpose({ onOpen, close });
</script>

<style scoped lang="scss">
.job-resize-modal {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  box-sizing: border-box;
  width: 100%;
  padding: 20px 16px 8px;
}

.job-resize-modal-anchor {
  position: absolute;
  width: 0;
  height: 0;
}
</style>
